import _ from 'lodash'

const MIN_LINK_GROUP = 0

/**
 * Given a list of filters, returns the linkGroup value that should be assigned
 * to a new filter.
 *
 * @param {Array} filters
 * @returns {number}
 */
function nextLinkGroup(filters=[]) {
	let max = _(filters).map(f => f.linkGroup).max()
	if (_.isNil(max)) {
		max = MIN_LINK_GROUP
	}
	return 1 + max
}

export default nextLinkGroup
export { MIN_LINK_GROUP }

nextLinkGroup.__filename__ = 'datasets/filters/next-link-group.js'
